import { Button, Card, CardActionArea, CardContent, CardHeader, CardMedia, Grid, IconButton, Typography } from '@material-ui/core';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import Delete from '@material-ui/icons/DeleteOutline';
import React, { useEffect, useState } from 'react';
import Loader from "react-loader-spinner";
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { selectUser } from '../../../../features/userSlice';
import db from '../../services/Firebase';
import { customStyles } from '../Styles/UIStyles';
import "./WebsiteForms.css"

export const ManageTestimonials = () => {
  const styles = customStyles();
  const history = useHistory();
  const userEmail = useSelector(selectUser)
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true)

  const fetchTestimonialsInfo = async () => {
    const list = [];
    var snapshot = await db.collection('TestimonialsInformation')
      .where("user_id", "==", userEmail)
      .get();
    snapshot.forEach((doc) => {
      list.push({ data: doc.data(), id: doc.id });
    });
    setTestimonials(list);
    setLoading(false);
  };

  useEffect(() => {
    fetchTestimonialsInfo();
  }, [])

  function deleteTestimonial(testimonial) {
    db.collection('TestimonialsInformation')
      .doc(testimonial.id)
      .delete()
      .then(resp => {
        window.location.reload();
      })
      .catch((error) => {
        alert(error.message);
      });
  }

  return (

    <div id="uniqueforms">
      <div>
        <h2 className={styles.section_header}>
          <p>
            <label htmlFor="icon-button-file">
              <IconButton className={styles.icon_button} aria-label="back-button" onClick={() => history.push("/coach-website")} >
                <ArrowBackIosIcon fontSize="small" />
              </IconButton>
            </label>
            Manage Testimonials
          </p>
        </h2>
        <Button className={styles.primary_button} variant="outlined" onClick={() => history.push("/add-testimonial")}> Add Testimonials </Button>
      </div>
      <br />
      <br />
      <Grid container justifyContent="flex-start" spacing={1} alignItems="stretch">
        {
          loading && (
            <Loader
              type="TailSpin"
              color="#00BFFF"
              height={100}
              width={100}
            />
          )
        }
        {
          !loading && testimonials.map(each_testimonial => {
            return (
              <Grid item key={each_testimonial.id}>
                <Card
                  className={styles.testimonial_card}
                >
                  <CardHeader
                    className={styles.testimonial_header}
                    action={
                      <IconButton aria-label="delete" onClick={() => deleteTestimonial(each_testimonial)}>
                        <Delete />
                      </IconButton>
                    }
                  />
                  <CardActionArea className={styles.testimonial_actionarea}
                    onClick={() => history.push(`/update-testimonial/${each_testimonial.id}`)}
                  >
                    <CardMedia
                      className={styles.testimonial_media}
                      component="img"
                      title='click to edit this testimonial'
                      src={each_testimonial.data.image}
                    />
                    <CardContent className={styles.testimonial_content}>
                      <Typography variant="h5" color="textPrimary" component="h3">
                        {each_testimonial.data.client_name}
                      </Typography>
                      <Typography nowrap="true" variant="body2" color="textSecondary" component="p">
                        {each_testimonial.data.testimonial_details}
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Grid>
            )
          })
        }
      </Grid>
    </div>
  )
}